





















































































































































import mixins from "vue-typed-mixins";
import MyMixin from "@/plugins/myMixin";
import { metadata } from "@/plugins/metadata";
import { types } from "@/services/westore/enums";

export default mixins(MyMixin).extend({
  name: "CustomsClearance",
  mounted() {
    this.trackMyPageView();
  },
  metaInfo: {
    title: metadata.CustomsClearance.title,
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      { charset: "utf-8" },
      { name: "robots", content: "follow, index" },
      {
        name: "description",
        content: metadata.CustomsClearance.description,
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1, user-scalable=no",
      },
    ],
  },
  methods: {
    showHideContactsCustom() {
      if (this.globals.whatsappPopupVisible) {
        this.logGAEvent("Let's Chat", "Whatsapp open", `Warehouse Page`);
      }
      this.globals.whatsappPopupVisible = !this.globals.whatsappPopupVisible;
    },
  },
  data: () => ({
    customsclearanceItems: [
      {
        title: "Taking care of all your paperwork",
        description:
          "When it comes to international shipments, we always have to deal with regulations,border control, and customs clearance. At times, this can be a confusing and lengthy process, which is why are offering to handle all the customs paperwork for you.No need to waste time and deal with red tape anymore! Our team knows exactly what needs to be done in order to adhere to all regulations and ensure a smooth and fast customs process.",
        imageUrl: require("../../assets/new-site/services/Customs-clearance1.jpg"),
      },
      {
        title: "Simplifying complex cases",
        description:
          "When it comes to international shipments, we always have to deal with regulations,border control, and customs clearance. At times, this can be a confusing and lengthy process, which is why are offering to handle all the customs paperwork for you.No need to waste time and deal with red tape anymore! Our team knows exactly what needs to be done in order to adhere to all regulations and ensure a smooth and fast customs process.",

        imageUrl: require("../../assets/new-site/services/Customs-clearance2.jpg"),
      },
    ],
  }),
  computed: {
    types() {
      return types;
    },
  },
});
